<template>
  <div class="tedetmenu">
    <div class="tl1 flex_start fanCollapse">
      <div class="labe">已选条件：</div>
      <div>
        <el-tag
          v-if="activlist.wt1"
          closable
          :disableTransitions="true"
          @close="Closepush()"
          type="info"
        >
          {{ activlist.wt1 }}
        </el-tag>

        <el-tag
          v-if="activlist.wt2"
          closable
          :disableTransitions="true"
          @close="handleClose('wt2')"
          type="info"
        >
          {{ activlist.wt2 }}
        </el-tag>
        <el-tag
          v-if="activlist.wt3"
          closable
          :disableTransitions="true"
          @close="handleClose('wt3')"
          type="info"
        >
          {{ activlist.wt3 }}
        </el-tag>
        <el-tag
          v-if="activlist.wt4"
          closable
          :disableTransitions="true"
          @close="handleClose('wt4')"
          type="info"
        >
          {{ activlist.wt4 }}
        </el-tag>
      </div>
    </div>
    <seafirapse
      class="fananxxqy"
      ref="wt2"
      v-show="!activlist.wt2"
      leftText=""
      :tagify="wt2"
      @clitag="clitag($event, 'wt2')"
    />
    <seafirapse
      class="fananxxqy"
      ref="wt3"
      v-show="activlist.wt2"
      :tagify="wt3"
      @clitag="clitag($event, 'wt3')"
      leftText=""
    />
    <seafirapse
      class="fananxxqy"
      :tagify="wt4"
      ref="wt4"
      leftText="擅长领域："
      @clitag="clitag($event, 'wt4')"
    />
  </div>
</template>

<script>
import seafirapse from "views/seafirms/components/seafirapse";
export default {
  components: {
    seafirapse,
  },
  data: () => ({
    activlist: {
      wt1: "安徽",
      wt2: "合肥",
      wt3: null,
      wt4: null,
    },
    wt2: [
      "合肥",
      "阜阳",
      "安庆",
      "蚌埠",
      "亳州",
      "池州",
      "滁州",
      "淮北",
      "淮南",
      "黄山",
      "六安",
      "马鞍山",
      "宿州",
      "铜陵",
      "芜湖",
      "宣城",
    ],
    wt3: [
      "巢湖市",
      "包河区",
      "长丰县",
      "肥东县",
      "肥西县",
      "庐江县",
      "庐阳区",
      "蜀山区",
      "瑶海区",
    ],
    wt4: [
      "离婚",
      "交通事故",
      "刑事辩护",
      "婚姻家庭",
      "工伤赔偿",
      "劳动纠纷",
      "房产纠纷",
      "土地纠纷",
      "债权债务",
      "医疗纠纷",
      "拆迁安置",
      "抵押担保",
      "合同纠纷",
      "法律顾问",
      "人身损害",
      "保险理赔",
      "工程建筑",
      "知识产权",
      "消费权益",
      "取保候审",
      "暴力犯罪",
      "毒品犯罪",
      "公司法",
      "公司上市",
      "股权激励",
      "股权纠纷",
      "经济犯罪",
      "金融证券",
      "改制重组",
    ],
  }),
  methods: {
    clitag(e, index) {
      this.activlist[index] = e;
    },
    Closepush(tag) {
      this.$router.push({
        path: "/findLawyers/lawyeroffice",
      });
    },
    handleClose(tag) {
      this.$refs[tag].condi("-1");
    },
  },
};
</script>

<style lang="scss" scoped>
.tedetmenu {
  width: 1200px;
  margin: 0 auto 30px;
  padding: 20px 24px 0;
background: #F8F8F8;
  .fananxxqy {
    border-bottom: 1px solid #eee;
    &:last-child {
      border-bottom: none;
    }
  }
  .tl1 {
    color: #999999;
    .labe {
      font-size: 12px;
      width: 80px;
      line-height: 30px;
    }
    .el-tag.el-tag--info {
      color: #333333;
      background-color: #f8f8f8;
    }
    .el-tag {
      margin-right: 10px;
      height: 20px;
      line-height: 18px;
    }
  }
}
</style>